import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpInterceptor,
  HttpResponse,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, throwError, of } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { KeycloakService } from "../keycloak.service";
import { HelperService } from "@app/shared/services/helper.service";
import { OrgAccessService } from "@app/shared/services/org-access.service";

@Injectable({
  providedIn: "root",
})
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private toasterService: ToastrService,
    private keycloakService: KeycloakService,
    private helperService: HelperService,
    private orgAccessService: OrgAccessService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((response: any) => {
        if (response.status === 401) {
          this.toasterService.error("Your session has expired. Please log in again.", "Unauthorized");
          if (this.helperService.embeddedMode.get()) {
            this.helperService.clearAllData();
            this.helperService.embeddedMode.set(true);
            this.helperService.notifyParentAuthEvent("unauthorized", {
              message: response?.error?.message || "Unauthorized",
            });
            return throwError(response);
          }

          if (this.helperService.keycloakSession.get()) {
            this.keycloakService.logout();
          } else {
            // Optional: Handle non-keycloak session expiry if needed
            this.router.navigate(["/auth/signin"]);
          }
          return throwError(response);
        } else if (this.orgAccessService.isOrgAccessDenied(response)) {
          // The active organization is no longer available to the user: let them switch or log out.
          this.orgAccessService.showInactiveOrgDialog();
          return throwError(response);
        } else if (response.status === 403) {
          this.toasterService.error("You don't have permission to access this resource.", "Forbidden");
          this.router.navigateByUrl(this.helperService.landingRoute()); // "/dashboard" alone has no page
          return throwError(response);
        } else if (response.status === 500) {
          //Interval server error
          this.toasterService.error("An unexpected server error occurred.", "Server Error");
          return throwError(response);
        } else {
          // For other errors, you might want a generic message
          const errorMessage = response?.error?.message || "An unknown error occurred.";
          this.toasterService.error(errorMessage, "Error");
          return throwError(response);
        }
      }),
      tap((res: any) => {
        if (res.status === 204) {
          // this.toasterService.error('No Record Found');
        }
      })
    );
  }
}
